import { Box, Divider, Flex, Group } from '@byecode/ui'
import type { IndependentAction, InputFlowArg, SubProcessArg } from '@lighthouse/core'
import { type FlowNode, ListItem4ByecodeUi, useAtomData } from '@lighthouse/shared'
import { find } from 'rambda'
import React, { useCallback, useMemo } from 'react'

import { workflowListAtom } from '@/atoms/workflow/state'
import { getWorkflowRootNode } from '@/utils'

import { SettingSubProcessContent } from '../Actions/component/SettingSubProcessContent'
import * as SC from '../styles'

interface HandleClickConfigureProps {
    value: InputFlowArg
    actionTypeSwitcher?: React.ReactNode
    allSingeParentNode?: FlowNode[]
    allParentNodes?: FlowNode[]
    allParentActions?: IndependentAction[]
    onChange: (value: InputFlowArg) => void
}

export const HandleClickConfigure: React.FC<HandleClickConfigureProps> = ({
    value,
    actionTypeSwitcher,
    allSingeParentNode,
    allParentNodes,
    allParentActions,
    onChange
}) => {
    const { flowId, args } = value
    const workflow = useAtomData(
        workflowListAtom,
        useCallback(workflows => find(item => item.id === flowId, workflows), [flowId])
    )
    const rootNode = getWorkflowRootNode(workflow)

    const subProcessArgs = useMemo(() => {
        if (rootNode && rootNode.data.nodeType === 'CLICK_TRIGGER') {
            if (!rootNode) {
                return
            }
            const { config } = rootNode.data
            const rootConfig = config
            if (!rootConfig || !rootConfig?.args) {
                return
            }
            // const data: SubProcessArg[] = getValues(`${prefixName}.args`)
            return rootConfig.args.map(item => {
                const dataItem = find(d => d.id === item.id, args || [])
                return {
                    ...item,
                    value: dataItem?.value
                }
            })
        }
    }, [args, rootNode])

    const handleChangeSubProcessArgs = useCallback(
        (data: SubProcessArg[]) => {
            onChange({ ...value, args: data })
        },
        [onChange, value]
    )

    return (
        <SC.Container>
            <Group label="动作配置">
                <ListItem4ByecodeUi>
                    <SC.FormItemLabelWrapper>
                        <SC.FormItemLabel>类型</SC.FormItemLabel>
                    </SC.FormItemLabelWrapper>
                    <Flex>{actionTypeSwitcher}</Flex>
                </ListItem4ByecodeUi>
            </Group>
            {rootNode?.data.nodeType === 'CLICK_TRIGGER' && subProcessArgs && subProcessArgs.length > 0 && (
                <>
                    <Divider color="var(--color-gray-200)" my={0} />
                    <Group label="流程参数值设置">
                        <Box px={8}>
                            <SettingSubProcessContent
                                data={subProcessArgs}
                                parentNodes={allSingeParentNode}
                                allParentNodes={allParentNodes}
                                allParentActions={allParentActions}
                                onChange={handleChangeSubProcessArgs}
                            />
                        </Box>
                    </Group>
                </>
            )}
        </SC.Container>
    )
}
